/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Информация о вложении
 */
export interface AttachmentSave {
  /** Идентификатор вложения */
  id?: string;

  /** Имя файла */
  fileName: string;

  /** Файл в формате base64 */
  encodedString?: string;

  /** Категория файла */
  category?: string;
}

/**
 * Список контрагентов
 */
export interface OperationContractor {
  /** Имя контрагента */
  name?: string;
}

/**
 * Информация для валютного контроля о валютном платеже
 */
export interface OperationSave {
  /** Идентификатор договора/контракта  */
  contractId?: string;

  /** Номер договора/контракта  */
  contractNumber?: string;

  /**
   * Дата договора/контракта
   * @format date
   */
  contractDate?: string;

  /** Уникальный номер контракта/кредитного договора  */
  contractUnk?: string;

  /** Сумма по коду вида операции */
  paySum?: number;

  /**
   * Код валюты
   * @example USD
   */
  payCurrency?: string;

  /**
   * Код валютной операции
   * @example 21200
   */
  kvo?: string;

  /**
   * Код валюты
   * @example USD
   */
  contractCurrency?: string;

  /** Сумма в валюте договора */
  contractCurrencySum?: number;

  /**
   * Ожидаемый срок
   * @format date
   */
  expectedDate?: string;

  /**
   * Срок возврата
   * @format date
   */
  refundDate?: string;

  /** Превышен ли лимит договора */
  contractLimit?: boolean;

  /** Контрагенты договора */
  contractors?: OperationContractor[];
}

/**
 * Информация о РПТС на сохранение
 */
export interface TransitAccountOrderSave {
  /**
   * Id транзитного счета
   * @format uuid
   */
  transitAccountId?: string;
  transitAccountNumber?: string;

  /**
   * Id счета для Перевода валюты в наш банк
   * @format uuid
   */
  currencyAccountId?: string;

  /**
   * Id счета для Продажи валюты в наш банк
   * @format uuid
   */
  rubleAccountId?: string;

  /** Выбранный кпп клиента */
  clientKpp?: string;

  /** Счет для Продажи валюты в внешний банк */
  accountNumberExtBank?: string;

  /** Наименование внешнего Банка для продажи */
  bankSaleName?: string;

  /** БИК внешнего Банка для продажи */
  bankSaleBIC?: string;

  /** Номер счета внешнего Банка для продажи */
  bankSaleCorrAccount?: string;

  /**
   * Id ответственного
   * @format uuid
   */
  responsibleId?: string;

  /** ФИО ответственного */
  responsibleFullName?: string;

  /** Номер телефона ответственного */
  responsiblePhoneNumber?: string;

  /**
   * Id зачисления
   * @format uuid
   */
  noticeEnrollmentId?: string;

  /**
   * Дата зачисления
   * @format date
   */
  notificationDate?: string;

  /** Номер зачисления */
  notificationNumber?: string;

  /** Сумма зачисления */
  allSum?: number;

  /** Сумма продажи */
  sumSale?: number;

  /** Валюта продажи */
  sumSaleCurr?: string;

  /** Сумма перевода */
  sumTransfer?: number;

  /** Валюта перевода */
  sumTransferCurr?: string;

  /** Суммы в разбивке по КВО */
  sums?: TransitAccountSumSave[];

  /** Вложения */
  attachments?: AttachmentSave[];

  /** Информация для валютного контроля */
  currencyControl?: OperationSave[];
}

/**
 * Информация о сумме по КВО
 */
export interface TransitAccountSumSave {
  /** Код вида операции */
  kvo?: string;

  /** Тип продажи */
  saleType?: string;

  /** Сумма по коду вида операции */
  sum?: number;
}

export interface ValidationItem {
  code?: string;
  message?: string;
  field?: string;
}

export interface ValidationResponse {
  errors?: ValidationItem[];
  warnings?: ValidationItem[];
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Данные сохраненного документа
 */
export interface DocumentSaveResponse {
  /** @format uuid */
  id: string;
  number: string;
  state: string;
  attachments?: AttachmentSave[];
}

/**
 * Данные банка на сохранение бенефециара
 */
export interface BeneficiaryBankSave {
  /** Наименование банка */
  name?: string;

  /** Адрес банка */
  address?: string;

  /** Город Банка */
  city?: string;

  /** Клиринговый код банка */
  clearingCode?: string;

  /**
   * Страна банка
   * @example GBR
   */
  countryId?: string;
}

/**
 * Параметры сохранения бенефициара
 */
export interface BeneficiarySave {
  /** Номер счета банка-бенефециара в банке-посреднике  */
  bankAgentAccountNumber?: string;

  /** Swift банка */
  bankSwift?: string;

  /** Данные банка на сохранение бенефециара  */
  bank?: BeneficiaryBankSave;

  /** Swift Банка посредника */
  bankAgentSwift?: string;

  /** Данные банка на сохранение бенефециара  */
  bankAgent?: BeneficiaryBankSave;

  /** Город */
  city?: string;

  /** ИНН (КИО) */
  inn?: string;

  /** Swift бенефициара */
  swift?: string;

  /** Счет или IBAN */
  account?: string;

  /** Международный адрес */
  addressInt?: string;

  /**
   * Код страны бенефициара
   * @example GBR
   */
  countryCode?: string;

  /** Международное наименование бенефициара */
  nameInt?: string;
}

/**
 * Информация о валютном платеже на сохранение
 */
export interface PaymentOrderSave {
  /**
   * Идентификатор счета
   * @format uuid
   */
  payerAccountId?: string;

  /** Город  */
  payerCity?: string;

  /** Международный адрес */
  payerAddress?: string;

  /** Международное наименование */
  payerName?: string;

  /** Международные реквизиты изменены */
  internationalChanged?: boolean;

  /** Сумма операции  */
  sum?: number;

  /**
   * Тип клиента
   * UL, BANK
   * @example BANK
   */
  clientType?: string;

  /** Выбранный кпп клиента */
  clientKpp?: string;

  /**
   * Тип Валютного платежа
   * МТ103, МТ202
   * @example MT103
   */
  swiftMessageType?: string;

  /** Номер внешнего счета плательщика */
  payerExternalAccountNumber?: string;

  /** Swift код банка клиента плательщика */
  payerBankSwift?: string;

  /** Наименование банка клиента плательщика */
  payerBankName?: string;

  /** Код страны банка клиента плательщика */
  payerBankCountryCode?: string;

  /** Город банка клиента плательщика */
  payerBankCity?: string;

  /** Описание платежа  */
  paymentDetails?: string;

  /**
   * Код платежа
   * @example OUR
   */
  chargeType?: string;

  /**
   * Счет списания комиссии
   * @format uuid
   */
  chargeAccountId?: string;

  /** Информация получателю */
  receiverInformation?: string;

  /** Контактное лицо */
  contact?: string;

  /** Контактный номер телефона */
  contactPhone?: string;

  /** Данные банка плательщика. Счет */
  payerBankAccount?: string;

  /** Идентификатор платежа (поле 20) */
  senderReference?: string;

  /** 121е поле. Уникальный референс транзакции */
  uetr?: string;

  /**
   * Дата валютирования
   * @format date
   */
  valueDate?: string;

  /** Данные валютного контроля */
  currencyControl?: OperationSave[];

  /** Список вложений */
  attachments?: AttachmentSave[];

  /** Перевод на свой счет */
  selfPayment?: boolean;

  /**
   * Код валюты
   * @example USD
   */
  currency?: string;

  /**
   * Идентификатор существующего бенефециара
   * @format uuid
   */
  beneficiarId?: string;

  /** Гарантированный платеж */
  chargeIsGrantType?: boolean;

  /** Параметры сохранения бенефициара  */
  beneficiar?: BeneficiarySave;
}

/**
 * Запрос на изменение признака мошенничества в платежном документе
 */
export interface RevokeFraudRequest {
  /**
   * Идентификатор документа
   * @format uuid
   * @example 3fa85f64-5717-4562-b3fc-2c963f66afa6
   */
  documentId: string;
  fraud?: boolean;
}

/**
 * Запрос на создание ИВО
 */
export interface CertCurrTransDocDetailCreateUpdateRequest {
  /** Номер счета по операциям */
  clientAcc?: string;

  /** Выбранный кпп клиента */
  clientKpp?: string;

  /** Номер кода страны банка нерезидента */
  countryNumCode?: string;

  /** ФИО ответственного по документу */
  responsiblePersonFio?: string;

  /** Телефон ответственного */
  responsiblePersonPhone?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Идентификатор корректировки */
  correctingId?: string;

  /**
   * Номер корректировки
   * @format int64
   */
  correctingNumber?: number;

  /**
   * Дата корректировки
   * @format date
   */
  correctingDate?: string;

  /**
   * Дата отправки документа в банк
   * @format date
   */
  sendDate?: string;

  /** Валюта счета */
  accountCurr?: string;

  /** Название банка нерезидента */
  nonresidentBankName?: string;

  /** Номер банка-нерезидента */
  nonresidentBankNum?: string;

  /** Счет банка нерезидента */
  nonresidentBankAccount?: string;

  /** Операции */
  operations?: CertCurrTransDocOperationRequest[];

  /** Список вложений */
  attachments?: AttachmentSave[];
}

/**
 * Операция в запросе создания ИВО
 */
export interface CertCurrTransDocOperationRequest {
  /** Идентификатор документа */
  documentId?: string;

  /** @format int64 */
  number?: number;

  /** Тип операции (если операция выбрана из списка) */
  type?: string;

  /** Идентификатор связанного документа */
  linkDocumentId?: string;

  /**
   * Дата связанного документа операции
   * @format date
   */
  linkDocumentDate?: string;

  /** Номер связанного документа операции) */
  linkDocumentNumber?: string;

  /**
   * Дата операции
   * @format date
   */
  operationDate?: string;

  /** Направление операции */
  direction?: string;

  /** Валюта перевода */
  currencyCode?: string;

  /** Идентификатор договора */
  contractId?: string;

  /** Номер договора */
  contractNumber?: string;

  /**
   * Дата договора
   * @format date
   */
  contractDate?: string;

  /** Уникальный номер договора */
  contractUniqueNumber?: string;

  /** Лимит */
  contractLimit?: boolean;

  /** Список контрагентов */
  contractors?: OperationContractor[];

  /** Сумма перевода */
  sum?: number;

  /** Код валютной операции */
  kvoCode?: string;

  /** Сумма в валюте договора */
  contractCurrencySum?: number;

  /** Валюта договора */
  contractCurrencyCode?: string;

  /** Цифровой код валюты операции */
  currencyNumCode?: string;

  /** Цифровой код валюты договора */
  contractCurrencyNumCode?: string;

  /**
   * Ожидаемый срок
   * @format date
   */
  expectedDate?: string;

  /**
   * Дата возврата аванса
   * @format date
   */
  refundDate?: string;

  /** Примечание */
  note?: string;

  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;
}

export interface ErrorMessage {
  /** @format uuid */
  id?: string;
  message?: string;
}

/**
 * Результат валидации документа с ошибкой
 */
export interface ImportErrorItem {
  /** Идентификатор платежа (поле 20) */
  reference?: string;

  /**
   * Порядковый номер документа в файле
   * @format int32
   */
  index?: number;

  /** Код ошибки */
  errorCode?: string;

  /** Текст ошибки */
  errorMessage?: string;
}

/**
 * Результат импорта документов
 */
export interface ImportResult {
  /** Наименование файла импорта */
  fileName?: string;

  /**
   * Количество документов в файле импорта
   * @format int32
   */
  allCount?: number;

  /**
   * Количество загруженных документов без ошибок
   * @format int32
   */
  importSuccessCount?: number;

  /**
   * Количество загруженных документов в черновик
   * @format int32
   */
  importDraftCount?: number;

  /**
   * Количество не загруженных документов
   * @format int32
   */
  importErrorCount?: number;

  /** Общая сумма перевода в импортированных документах */
  importedSum?: ImportSumStat[];

  /** Общая сумма перевода в импортированных документах-черновиках */
  draftSum?: ImportSumStat[];
  importSuccess?: ImportSuccessItem[];
  importError?: ImportErrorItem[];
}

/**
 * Результат успешного импорта документа
 */
export interface ImportSuccessItem {
  /** Идентификатор платежа (поле 20) */
  reference?: string;

  /**
   * Порядковый номер документа в файле
   * @format int32
   */
  index?: number;

  /**
   * Id документа
   * @format uuid
   */
  documentId?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Код ошибки */
  errorCode?: string;

  /** Текст ошибки */
  errorMessage?: string;
}

/**
 * Общая сумма перевода в импортированных документах-черновиках
 */
export interface ImportSumStat {
  /** Валюта перевода */
  currencyCode?: string;

  /** Сумма перевода */
  sum?: number;
}

/**
 * Результат валидации документов на импорт
 */
export interface ImportValidateResult {
  /** Наименование файла импорта */
  fileName?: string;

  /**
   * Количество документов в файле импорта
   * @format int32
   */
  allCount?: number;

  /**
   * Количество успешно прошедших валидацию документов
   * @format int32
   */
  successCount?: number;

  /**
   * Количество документов с ошибками валидации
   * @format int32
   */
  errorCount?: number;
  successSums?: ImportValidateSumStat[];
  errorSums?: ImportValidateSumStat[];
  errors?: ImportErrorItem[];
}

export interface ImportValidateSumStat {
  /** Валюта перевода */
  currencyCode?: string;

  /** Сумма перевода */
  sum?: number;
}

/**
 * Информация о вложении
 */
export interface Attachment {
  /** Идентификатор вложения */
  id: string;

  /** Внешний идентификатор документа */
  fileId: string;

  /**
   * Идентификатор документа к которому прикреплено вложение
   * @format uuid
   */
  documentId: string;

  /** Готовность файла */
  ready: boolean;

  /** Код ошибки */
  errorCode: string;

  /** Текст ошибки */
  errorDescription: string;

  /**
   * Размер
   * @format int64
   */
  size: number;

  /** Категория */
  category?: string;

  /** Имя файла */
  fileName: string;
}

/**
 * Полномочие
 */
export interface Permission {
  /** Название действия */
  name: string;

  /** Признак доступности действия */
  isAvailable: boolean;

  /** Описание действия */
  desc: string;
}

/**
 * Список РПТС
 */
export interface TransitAccountList {
  hasMore?: boolean;

  /** @format int32 */
  totalPagesCount?: number;

  /** @format int32 */
  totalRowsCount?: number;
  data?: TransitAccountOrderShort[];
}

/**
 * Информация о РПТС
 */
export interface TransitAccountOrderShort {
  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Номер валютного счета для перевода */
  currencyAccountNumber?: string;

  /** Сумма для перевода */
  sumTransfer?: number;

  /** Номер валютного счета для продажи */
  rubleAccountNumber?: string;

  /** Сумма для продажи */
  sumSale?: number;

  /** БИК банка для продажи в внешний банк */
  bankSaleBIC?: string;

  /** Номер рублевого счета для продажи в внешний банк */
  accountNumberExtBank?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Статус документа */
  state?: string;

  /**
   * Дата уведомления
   * @format date
   */
  notificationDate?: string;

  /** Номер уведомления */
  notificationNumber?: string;

  /** Сумма уведомления */
  allSum?: number;

  /** Валюта уведомления */
  currencySumReceipt?: string;

  /**
   * Валюта уведомления
   * currencySumReceipt
   */
  currencyCodeAllSumReceipt?: string;

  /** Признак наличия досыла */
  hasFileSending?: boolean;

  /** Полномочия */
  permissions?: Permission[];

  /** Признак наличия вложений */
  isAttachment?: boolean;

  /** Список контрактов */
  contractIds?: string[];
}

/**
 * Информация о связи
 */
export interface Link {
  /**
   * Идентификатор объекта, создателя связи
   * @format uuid
   */
  ownerId?: string;

  /** Тип объекта, создателя связи */
  ownerType?: string;

  /** Номер объекта-документа, создателя связи */
  ownerDocumentNumber?: string;

  /**
   * Дата объекта-документа, создателя связи
   * @format date
   */
  ownerDocumentDate?: string;

  /** Статус объекта-документа, создателя связи */
  ownerDocumentState?: string;

  /** Идентификатор связанного объекта */
  referenceId?: string;

  /** Идентификатор связанного объекта */
  referenceType?: string;

  /** Номер связанного объекта-документа */
  referenceDocumentNumber?: string;

  /**
   * Дата связанного объекта-документа
   * @format date
   */
  referenceDocumentDate?: string;

  /** Статус связанного объекта-документа */
  referenceDocumentState?: string;
}

/**
 * Информация для валютного контроля о валютном платеже
 */
export interface Operation {
  /** Идентификатор договора/контракта  */
  contractId?: string;

  /** Номер договора/контракта  */
  contractNumber?: string;

  /**
   * Дата договора/контракта
   * @format date
   */
  contractDate?: string;

  /** Уникальный номер контракта/кредитного договора  */
  contractUnk?: string;

  /** Сумма по коду вида операции */
  paySum?: number;

  /**
   * Код валюты
   * @example USD
   */
  payCurrency?: string;

  /**
   * Код валютной операции
   * @example 21200
   */
  kvo?: string;

  /**
   * Код валюты договора
   * @example USD
   */
  contractCurrency?: string;

  /** Сумма в валюте договора */
  contractCurrencySum?: number;

  /**
   * Ожидаемый срок
   * @format date
   */
  expectedDate?: string;

  /**
   * Срок возврата
   * @format date
   */
  refundDate?: string;

  /** Порядковый номер операции */
  number?: string;

  /** Тип операции */
  type?: string;

  /** Направление операции */
  direction?: string;

  /** Номер документа операции */
  documentNumber?: string;

  /**
   * Дата документа операции
   * @format date
   */
  documentDate?: string;

  /** Лимит операции */
  contractLimit?: boolean;

  /** Контрагенты договора */
  contractors?: OperationContractor[];
}

/**
 * Детальная информация о РПТС
 */
export interface TransitAccountOrderDetails {
  /**
   * Id документа
   * @format uuid
   */
  id?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Статус документа */
  state?: string;

  /** Описание статуса документа */
  stateDesc?: string;

  /**
   * Дата создания платежного документа
   * @format date
   */
  sendDate?: string;

  /** Номер счета для Перевода валюты в наш банк */
  currencyAccountNumber?: string;

  /**
   * Id счета для Перевода валюты в наш банк
   * @format uuid
   */
  currencyAccountId?: string;

  /**
   * Id счета для Продажи валюты в наш банк
   * @format uuid
   */
  rubleAccountId?: string;

  /** Номер счета для Продажи валюты в наш банк */
  rubleAccountNumber?: string;

  /** Счет для Продажи валюты в внешний банк */
  accountNumberExtBank?: string;

  /**
   * Id зачисления
   * @format uuid
   */
  noticeEnrollmentId?: string;

  /**
   * Дата зачисления
   * @format date
   */
  notificationDate?: string;

  /** Номер зачисления */
  notificationNumber?: string;

  /** Сумма зачисления */
  allSum?: number;

  /** Наименование внешнего Банка для продажи */
  bankSaleName?: string;

  /** БИК внешнего Банка для продажи */
  bankSaleBIC?: string;

  /** Номер счета внешнего Банка для продажи */
  bankSaleCorrAccount?: string;
  bankInfoComment?: string;
  bankInfoEmployee?: string;
  bankInfoEmployeeName?: string;

  /** @format date */
  bankInfoProcessDate?: string;

  /** @format date */
  bankInfoReceiveDate?: string;
  bankInfoRejectReason?: string;

  /**
   * Id транзитного счета
   * @format uuid
   */
  transitAccountId?: string;

  /** Валюта транзитного счета */
  transitAccountCurrency?: string;

  /** Номер транзитного счета */
  transitAccountNumber?: string;

  /**
   * Id ответственного
   * @format uuid
   */
  responsibleId?: string;

  /** ФИО ответственного */
  responsibleFullName?: string;

  /** Номер телефона ответственного */
  responsiblePhoneNumber?: string;

  /**
   * Id клиента
   * @format uuid
   */
  client?: string;
  clientINN?: string;
  clientName?: string;
  clientOGRN?: string;
  clientOKPO?: string;
  clientPhoneNumber?: string;

  /** Выбранный кпп клиента */
  clientKpp?: string;

  /** Сумма продажи */
  sumSale?: number;

  /** Валюта продажи */
  sumSaleCurr?: string;

  /** Сумма перевода */
  sumTransfer?: number;

  /** Валюта перевода */
  sumTransferCurr?: string;

  /** Суммы в разбивке по КВО */
  sums?: TransitAccountSum[];

  /** Вложения */
  attachments?: Attachment[];

  /** Информация для валютного контроля */
  currencyControl?: Operation[];

  /** Полномочия */
  permissions?: Permission[];

  /** Отправлен в банк */
  isSent?: boolean;

  /** Связи */
  links?: Link[];

  /** Признак наличия досыла */
  hasFileSending?: boolean;

  /**
   * ИД отзыва
   * @format uuid
   */
  revokeId?: string;
}

/**
 * Информация о сумме по КВО
 */
export interface TransitAccountSum {
  /** Код вида операции */
  kvo?: string;

  /** Тип продажи */
  saleType?: string;

  /** Сумма по коду вида операции */
  sum?: number;
}

/**
 * Постраничный список выписок
 */
export interface PageWrappedStatementResponse {
  hasMore?: boolean;

  /** @format int32 */
  totalRowsCount?: number;
  data?: StatementResponse[];
}

/**
 * Информация о выписке
 */
export interface StatementResponse {
  /** @format uuid */
  id?: string;
  accountNumber?: string;
  senderReference?: string;
  pageInfo?: string;
  amount?: number;
  currency?: string;
  messageType?: string;

  /** @format date */
  date?: string;

  /** @format int32 */
  page?: number;
}

/**
 * Настройка
 */
export interface Setting {
  code?: string;
  value?: string;
}

/**
 * Список настроек
 */
export interface SettingsResponse {
  settings?: Setting[];
}

/**
 * Список привилегий документа
 */
export interface PermissionListResponse {
  /** Тип документа */
  entityStrId?: string;

  /** Список разрешений */
  permissions?: Permission[];
}

/**
 * Базовое наполнение заявления о переводе
 */
export interface PaymentOrderBase {
  /**
   * id
   * @format uuid
   */
  id?: string;

  /** Состояние документа */
  status?: string;

  /** Название бенефициара */
  beneficiarName?: string;

  /** SWIFT банка бенефициара */
  beneficiarSwift?: string;

  /** Наименование банка бенефициара */
  beneficiarBank?: string;

  /** Валюта списания */
  payerAccountCurrency?: string;

  /** Сумма перевода */
  sum?: number;

  /** Валюта перевода */
  payCurrency?: string;

  /** Полномочия */
  permissions?: Permission[];

  /** Признак наличия досыла */
  hasFileSending?: boolean;

  /** Признак наличия вложений */
  isAttachment?: boolean;

  /** Список контрактов */
  contractIds?: string[];

  /** Сообщение формата SWIFT MT103 заполнено */
  hasSwiftMessage?: boolean;

  /** Номер документа */
  number?: string;

  /**
   * Дата документа
   * @format date
   */
  date?: string;

  /** Назначение платежа */
  purpose?: string;
}

/**
 * Список заявлений о переводе
 */
export interface PaymentOrderBaseList {
  hasMore?: boolean;

  /** @format int32 */
  totalPagesCount?: number;

  /** @format int32 */
  totalRowsCount?: number;
  data?: PaymentOrderBase[];
}

/**
 * Данные банка на деталку бенефециара
 */
export interface BeneficiaryBankDetail {
  /** Наименование банка */
  name?: string;

  /** Адрес банка */
  address?: string;

  /** Город Банка */
  city?: string;

  /** Клиринговый код банка */
  clearingCode?: string;

  /** Swift */
  swift?: string;

  /**
   * Страна банка
   * @example GBR
   */
  countryCode?: string;

  /**
   * Наименование страны банка
   * @example UNITED KINGDOM
   */
  countryName?: string;
}

/**
 * Подробная информация о валютном платеже
 */
export interface PaymentOrderDetail {
  /** Город */
  payerCity?: string;

  /** Международный адрес */
  payerAddress?: string;

  /**
   * Идентификатор плательщика
   * @format uuid
   */
  payerClientId?: string;

  /** Выбранный кпп клиента */
  clientKpp?: string;

  /** Международное наименование */
  payerName?: string;

  /** Международные реквизиты изменены */
  internationalChanged?: boolean;

  /** Сумма операции  */
  sum?: number;

  /** Номер документа  */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Статус документа  */
  documentState?: string;

  /** Описание статуса документа  */
  documentStateDesc?: string;

  /** Тип клиента */
  clientType?: "BANK" | "UL";

  /** Имя плательщика */
  payerClientName?: string;

  /**
   * Дата создания платежного документа
   * @format date
   */
  sendDate?: string;

  /**
   * Идентификатор счета плательщика
   * @format uuid
   */
  accountId?: string;

  /** Номер счета плательщика  */
  accountNumber?: string;

  /** Валюта счета плательщика  */
  accountCurrency?: string;

  /** Описание платежа  */
  paymentDetails?: string;

  /** Код платежа:   OUR   SHA   BEN  */
  chargeType?: string;

  /**
   * Идентификатор счета комиссии плательщика
   * @format uuid
   */
  chargeAccountId?: string;

  /** Номер счета комиссии плательщика  */
  chargeAccountNumber?: string;

  /** Валюта счета комиссии плательщика  */
  chargeAccountCurrency?: string;

  /** Информация получателю */
  receiverInformation?: string;

  /** Тип валютного платежа: MT103/MT202 */
  swiftMessageType?: "MT103" | "MT202";

  /** Контактное лицо */
  contact?: string;

  /** Контактный номер телефона */
  contactPhone?: string;

  /** Отправлен в банк */
  isSent?: boolean;

  /** Список операций для валютного контроля */
  currencyControl?: Operation[];

  /** Список вложений */
  attachments?: Attachment[];

  /** Список полномочий */
  permissions?: Permission[];

  /** Свифт код */
  payerBankSwift?: string;

  /** Номер счета плательщик */
  payerExternalAccountNumber?: string;

  /** Данные банка плательщика. Название */
  payerBankName?: string;

  /** Данные банка плательщика. Код страны */
  payerBankCountryCode?: string;

  /** Данные банка плательщика. Город */
  payerBankCity?: string;

  /** Данные банка плательщика. Счет */
  payerBankAccount?: string;

  /** Идентификатор платежа (поле 20) */
  senderReference?: string;

  /** 121е поле. Уникальный референс транзакции */
  uetr?: string;

  /**
   * Дата валютирования
   * @format date
   */
  valueDate?: string;

  /** Связи */
  links?: Link[];

  /** Признак наличия досыла */
  hasFileSending?: boolean;

  /** Признак входящего документа */
  incoming?: boolean;

  /**
   * ИД отзыва
   * @format uuid
   */
  revokeId?: string;

  /** Перевод на свой счет */
  selfPayment?: boolean;

  /** Сообщение формата SWIFT MT103 заполнено */
  hasSwiftMessage?: boolean;

  /**
   * Идентификатор бенефециара
   * @format uuid
   */
  beneficiarId?: string;

  /** Наименование бенефециара  */
  beneficiarName?: string;

  /** ИНН бенефециара */
  beneficiarInn?: string;

  /** Страна бенефециара  */
  beneficiarCountry?: string;

  /** Город бенефециара  */
  beneficiarCity?: string;

  /** Адрес бенефециара  */
  beneficiarAddress?: string;

  /** Swift бенефециара если это банк */
  beneficiarySwift?: string;

  /** Номер счета бенефециара  */
  beneficiarAccountNumber?: string;

  /** Номер счета бенефециара в банке-посреднике  */
  beneficiarAgentAccountNumber?: string;

  /** Данные банка на деталку бенефециара  */
  beneficiarBank?: BeneficiaryBankDetail;

  /** Данные банка на деталку бенефециара  */
  beneficiarAgentBank?: BeneficiaryBankDetail;

  /** Код валюты:   USD - Доллар   EUR - Евро  */
  currency?: string;

  /**
   * Дата создания платежного документа
   * @format date-time
   */
  createDate?: string;

  /** Гарантированный платеж */
  chargeIsGrantType?: boolean;
}

/**
 * Валюта
 */
export interface Currency {
  name?: string;
  alphabeticCode?: string;
  numericCode?: string;
  okvName?: string;
  isActive?: boolean;

  /** @format int32 */
  accuracy?: number;
}

/**
 * Список ИВО для клиента
 */
export interface CertCurrTransDoc {
  /**
   * Идентификатор ИВО
   * @format uuid
   */
  id?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Статус */
  state?: string;

  /** ИНН клиента */
  clientInn?: string;

  /** Наименование клиента */
  clientName?: string;

  /** КПП клиента */
  clientKpp?: string;

  /** Досыл */
  hasFileSending?: boolean;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Операции */
  operations?: CertCurrTransDocGetOperation[];

  /** Полномочия */
  permissions?: Permission[];

  /** Список контрактов */
  contractIds?: string[];
  attachment?: boolean;
}

/**
 * Список операций ИВО для клиента
 */
export interface CertCurrTransDocGetOperation {
  /**
   * Идентификатор операции
   * @format uuid
   */
  id?: string;

  /** Тип операции (если операция выбрана из списка) */
  type?: string;

  /** Номер операции */
  payDocNumber?: string;

  /**
   * Дата операции
   * @format date
   */
  payDocDate?: string;

  /** Буквенный код валюты операции */
  paymentCurrCode?: string;

  /**
   * Цифровой код валюты операции
   * @format int64
   */
  paymentCurrIso?: number;

  /** Описание валюты операции */
  paymentCurrDesc?: string;

  /** УНК */
  trPassportNumber?: string;

  /** Номер договора */
  stReservNumber?: string;

  /**
   * Дата договора
   * @format date
   */
  stReservDate?: string;

  /** Сумма оплаты */
  paymentSum?: number;

  /** Сумма договора */
  sumContractCurr?: number;

  /** Буквенный код валюты договора */
  contractCurrCode?: string;

  /**
   * Цифровой код валюты договора
   * @format int64
   */
  contractCurrIso?: number;

  /** Описание валюты договора */
  contractCurrDesc?: string;
}

/**
 * Список ИВО
 */
export interface CertCurrTransDocList {
  /** Список ИВО */
  certCurrTransDocEntries?: PageCertCurrTransDoc;

  /**
   * Размер возвращаемого списка ИВО
   * @format int32
   */
  size?: number;
  hasMore?: boolean;
}

/**
 * Список ИВО
 */
export interface PageCertCurrTransDoc {
  /** @format int32 */
  totalPages?: number;

  /** @format int64 */
  totalElements?: number;

  /** @format int32 */
  size?: number;
  content?: CertCurrTransDoc[];

  /** @format int32 */
  number?: number;
  sort?: SortObject;
  first?: boolean;

  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  last?: boolean;
  empty?: boolean;
}

export interface PageableObject {
  /** @format int64 */
  offset?: number;
  sort?: SortObject;

  /** @format int32 */
  pageNumber?: number;

  /** @format int32 */
  pageSize?: number;
  paged?: boolean;
  unpaged?: boolean;
}

export interface SortObject {
  empty?: boolean;
  sorted?: boolean;
  unsorted?: boolean;
}

/**
 * Информация о вложении для ИВО для АРМ Сотрудника
 */
export interface AttachmentUnit {
  /** Идентификатор вложения */
  id: string;

  /** Идентификатор файла */
  fileId: string;

  /**
   * Размер файла
   * @format int64
   */
  size: number;

  /** Готовность файла */
  ready: boolean;

  /** Код ошибки */
  errorCode: string;

  /** Текст ошибки */
  errorDescription: string;

  /** Категория */
  category: string;

  /** Имя файла */
  fileName: string;
}

/**
 * Подробная информация по ИВО
 */
export interface CertCurrTransDocDetailResponse {
  /** Идентификатор документа */
  id?: string;

  /** Статус */
  state?: string;
  stateDesc?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Наименование банка */
  clientBankName?: string;

  /** Клиент */
  client?: Client;

  /** Номер счета по операциям */
  clientAcc?: string;

  /** Выбранный кпп клиента */
  clientKpp?: string;

  /** Номер кода страны банка нерезидента */
  countryNumCode?: string;

  /** ФИО ответственного по документу */
  responsiblePersonFio?: string;

  /** Телефон ответственного */
  responsiblePersonPhone?: string;

  /** Признак корректировки */
  isCorrecting?: boolean;

  /** Признак наличия досыла */
  hasFileSending?: boolean;
  correctingId?: string;
  correctingNumber?: string;

  /** @format date */
  correctingDate?: string;

  /**
   * Дата отправки документа в банк
   * @format date
   */
  sendDate?: string;

  /** Валюта счета */
  accountCurr?: string;

  /** ФИО Сотрудника банка */
  bankInfoEmployeeName?: string;

  /**
   * Обработано
   * @format date
   */
  bankInfoProcessDate?: string;

  /** Причина отказа */
  bankInfoRejectReason?: string;

  /** Комментарий */
  bankInfoComment?: string;

  /** Операции */
  operations?: CertCurrTransDocOperationResponse[];

  /** Вложения */
  attachments?: AttachmentUnit[];

  /** Связи */
  links?: Link[];

  /** Полномочия */
  permissions?: Permission[];

  /**
   * ИД отзыва
   * @format uuid
   */
  revokeId?: string;

  /** Название банка нерезидента */
  nonresidentBankName?: string;

  /** Номер банка-нерезидента */
  nonresidentBankNum?: string;

  /** Счет банка нерезидента */
  nonresidentBankAccount?: string;
}

/**
 * Операция в детальной форме ИВО
 */
export interface CertCurrTransDocOperationResponse {
  /** Идентификатор документа */
  documentId?: string;

  /** @format int64 */
  number?: number;

  /** Тип операции (если операция выбрана из списка) */
  type?: string;

  /** Идентификатор связанного документа */
  linkDocumentId?: string;

  /**
   * Дата связанного документа операции
   * @format date
   */
  linkDocumentDate?: string;

  /** Номер связанного документа операции) */
  linkDocumentNumber?: string;

  /**
   * Дата операции
   * @format date
   */
  operationDate?: string;

  /** Направление операции */
  direction?: string;

  /** Валюта перевода */
  currencyCode?: string;

  /** Идентификатор договора */
  contractId?: string;

  /** Номер договора */
  contractNumber?: string;

  /**
   * Дата договора
   * @format date
   */
  contractDate?: string;

  /** Уникальный номер договора */
  contractUniqueNumber?: string;

  /** Лимит */
  contractLimit?: boolean;

  /** Список контрагентов */
  contractors?: OperationContractor[];

  /** Сумма перевода */
  sum?: number;

  /** Цифровой код валюты операции */
  currencyNumCode?: string;

  /** Цифровой код валюты договора */
  contractCurrencyNumCode?: string;

  /** Код валютной операции */
  kvoCode?: string;

  /** Сумма в валюте договора */
  contractCurrencySum?: number;

  /** Валюта договора */
  contractCurrencyCode?: string;

  /**
   * Ожидаемый срок
   * @format date
   */
  expectedDate?: string;

  /**
   * Дата возврата аванса
   * @format date
   */
  refundDate?: string;

  /** Примечание */
  note?: string;

  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;
}

/**
 * Клиент
 */
export interface Client {
  /** Наименование резидента */
  clientName?: string;

  /** ИНН */
  clientInn?: string;

  /** КПП */
  clientKpp?: string;
}

/**
 * Список ИВО
 */
export interface CertCurrTransDocListV2 {
  hasMore?: boolean;

  /** @format int32 */
  totalRowsCount?: number;
  data?: CertCurrTransDoc[];
}

/**
 * Информация о зачислениях
 */
export interface NoticeEnrollment {
  /** @format uuid */
  id?: string;
  trAcc?: string;

  /** @format uuid */
  trAccId?: string;
  sum?: number;
  curCode?: string;
  curNotifyType?: string;

  /** @format date */
  documentDate?: string;
  documentNumber?: string;

  /** @format date */
  recDate?: string;
  state?: string;
  currControlState?: string;
  isExpired?: boolean;
}

/**
 * Список оповещений
 */
export interface RowsWrappedNoticeEnrollment {
  hasMore?: boolean;

  /** @format int32 */
  totalRowsCount?: number;
  data?: NoticeEnrollment[];
}

/**
 * Детальная информация о зачислениях
 */
export interface NoticeEnrollmentDetail {
  /** @format uuid */
  id?: string;
  addInformation?: string;
  enrollmentType?: string;

  /** @format uuid */
  clientId?: string;
  clientName?: string;

  /** @format uuid */
  currencyId?: string;
  currencyCode?: string;

  /** @format date */
  dateNotLater?: string;
  sum?: number;

  /** @format uuid */
  traccId?: string;
  traccNumber?: string;
  documentNumber?: string;

  /** @format date */
  documentDate?: string;
  state?: string;

  /** @format date-time */
  dateCreate?: string;

  /** @format date-time */
  stateChangeDate?: string;

  /** @format date */
  recDate?: string;
  swiftMt?: string;
  noticeText?: string;
  links?: Link[];
}

/**
 * Общая структура для документов разного типа
 */
export interface CommonDocument {
  /**
   * Id документа
   * @format uuid
   */
  id?: string;

  /** Тип документа */
  type?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Статус документа */
  state?: string;

  /** Наличие досыла документа */
  hasFileSending?: boolean;

  /** Id отзыва документа */
  revokeId?: string;

  /** Список ИВО для клиента */
  certCurrTransDoc?: CertCurrTransDoc;

  /** Базовое наполнение заявления о переводе */
  paymentOrderCurrency?: PaymentOrderBase;

  /** Информация о РПТС */
  transitAccountOrder?: TransitAccountOrderShort;

  /** Полномочия */
  permissions?: Permission[];
}

/**
 * Постраничный список 'Общая структура для документов разного типа'
 */
export interface PageWrappedDocumentCommon {
  hasMore?: boolean;

  /** @format int32 */
  totalPagesCount?: number;

  /** @format int32 */
  totalRowsCount?: number;
  data?: CommonDocument[];
}

/**
 * Swift банк
 */
export interface Swift {
  /** @format uuid */
  id?: string;
  swift?: string;
  name?: string;
  country?: string;
  city?: string;
  address?: string;
}

/**
 * Swift банк
 */
export interface RuBank {
  /** @format uuid */
  id?: string;
  name: string;
  bic: string;
  swift?: string;
  region?: string;
  placeType?: string;
  place?: string;
  address?: string;
  countryCode?: string;
  corrAccount?: string;
}

/**
 * Код валютной операции
 */
export interface CurOperCode {
  code: string;
  description?: string;

  /**
   * Дата начала действия КВО
   * @format date
   */
  dateStart?: string;

  /**
   * Дата окончания действия КВО
   * @format date
   */
  dateFinish?: string;
}

/**
 * Страна
 */
export interface Country {
  codeIso?: string;
  shortName?: string;
  fullName?: string;
  englishName?: string;
  charCode2?: string;
  charCode3?: string;
}

/**
 * Счет
 */
export interface Account {
  /** @format uuid */
  id?: string;
  number?: string;
  name?: string;
  currency?: string;
  balance?: number;
  type?: string;

  /** @format date */
  openDate?: string;

  /** @format date */
  closeDate?: string;
}

/**
 * Поля ККБ
 */
export type CcbFields = object;

/**
 * Документ
 */
export interface DocumentOrderCcbResponse {
  /** Тип документа */
  type?: DocumentTypeOrderCcbResponse;

  /** Поля ККБ */
  fields?: CcbFields;
}

/**
 * Тип документа
 */
export interface DocumentTypeOrderCcbResponse {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: DocumentOrderCcbResponse;
}

/**
 * Тип подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Код
 */
export interface Code {
  code?: string;
  description?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис Валютное РКО
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-currency-rko.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Валютное РКО (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=121435090)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags РПТС
     * @name GetTransitAccountOrder
     * @summary Получение детальной информации
     * @request GET:/api/currency-rko/v1/external/transit_order_account/{id}
     * @secure
     */
    getTransitAccountOrder: (id: string, params: RequestParams = {}) =>
      this.request<TransitAccountOrderDetails, GenericError>({
        path: `/api/currency-rko/v1/external/transit_order_account/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags РПТС
     * @name UpdateTransitAccountOrder
     * @summary Редактирование
     * @request PUT:/api/currency-rko/v1/external/transit_order_account/{id}
     * @secure
     */
    updateTransitAccountOrder: (
      id: string,
      data: TransitAccountOrderSave,
      query?: { draft?: boolean; ignoreWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<
        DocumentSaveResponse,
        GenericError | void | ValidationResponse
      >({
        path: `/api/currency-rko/v1/external/transit_order_account/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags РПТС
     * @name DeleteTransitAccountOrder
     * @summary Удаление
     * @request DELETE:/api/currency-rko/v1/external/transit_order_account/{id}
     * @secure
     */
    deleteTransitAccountOrder: (id: string, params: RequestParams = {}) =>
      this.request<void, void | GenericError>({
        path: `/api/currency-rko/v1/external/transit_order_account/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Валютный платеж
     * @name GetPaymentOrder
     * @summary Получение детальной информации
     * @request GET:/api/currency-rko/v1/external/payment/{id}
     * @secure
     */
    getPaymentOrder: (id: string, params: RequestParams = {}) =>
      this.request<PaymentOrderDetail, GenericError>({
        path: `/api/currency-rko/v1/external/payment/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Валютный платеж
     * @name UpdatePaymentOrder
     * @summary Редактирование
     * @request PUT:/api/currency-rko/v1/external/payment/{id}
     * @secure
     */
    updatePaymentOrder: (
      id: string,
      data: PaymentOrderSave,
      query?: { draft?: boolean; ignoreWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<
        DocumentSaveResponse,
        GenericError | void | ValidationResponse
      >({
        path: `/api/currency-rko/v1/external/payment/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Валютный платеж
     * @name DeletePaymentOrder
     * @summary Удаление
     * @request DELETE:/api/currency-rko/v1/external/payment/{id}
     * @secure
     */
    deletePaymentOrder: (id: string, params: RequestParams = {}) =>
      this.request<void, void | GenericError>({
        path: `/api/currency-rko/v1/external/payment/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Валютный платеж
     * @name UpdateFraud
     * @summary Изменение признака мошенничества
     * @request PUT:/api/currency-rko/v1/external/payment/revoke-fraud
     * @secure
     */
    updateFraud: (data: RevokeFraudRequest, params: RequestParams = {}) =>
      this.request<void, void | GenericError>({
        path: `/api/currency-rko/v1/external/payment/revoke-fraud`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ИВО
     * @name GetCertCurrTransDocById
     * @summary Получение детальной формы ИВО по id для клиента
     * @request GET:/api/currency-rko/v1/external/ivo/{id}
     * @secure
     */
    getCertCurrTransDocById: (id: string, params: RequestParams = {}) =>
      this.request<CertCurrTransDocDetailResponse, ErrorMessage>({
        path: `/api/currency-rko/v1/external/ivo/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ИВО
     * @name UpdateCertCurrTransDoc
     * @summary Обновление ИВО
     * @request PUT:/api/currency-rko/v1/external/ivo/{id}
     * @secure
     */
    updateCertCurrTransDoc: (
      id: string,
      data: CertCurrTransDocDetailCreateUpdateRequest,
      query?: { draft?: boolean; ignoreWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorMessage>({
        path: `/api/currency-rko/v1/external/ivo/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ИВО
     * @name DeletePaymentOrder1
     * @summary Удаление ИВО
     * @request DELETE:/api/currency-rko/v1/external/ivo/{id}
     * @secure
     */
    deletePaymentOrder1: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/currency-rko/v1/external/ivo/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags РПТС
     * @name GetTransitAccountOrderList
     * @summary Получение списка
     * @request GET:/api/currency-rko/v1/external/transit_order_account
     * @secure
     */
    getTransitAccountOrderList: (
      query: { page: number; size: number },
      params: RequestParams = {}
    ) =>
      this.request<TransitAccountList, GenericError>({
        path: `/api/currency-rko/v1/external/transit_order_account`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags РПТС
     * @name CreateTransitAccountOrder
     * @summary Создание
     * @request POST:/api/currency-rko/v1/external/transit_order_account
     * @secure
     */
    createTransitAccountOrder: (
      data: TransitAccountOrderSave,
      query?: { draft?: boolean; ignoreWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError | ValidationResponse>({
        path: `/api/currency-rko/v1/external/transit_order_account`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Валютный платеж
     * @name GetPaymentOrderList
     * @summary Получение списка
     * @request GET:/api/currency-rko/v1/external/payment
     * @secure
     */
    getPaymentOrderList: (
      query: { page: number; size: number },
      params: RequestParams = {}
    ) =>
      this.request<PaymentOrderBaseList, GenericError>({
        path: `/api/currency-rko/v1/external/payment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Валютный платеж
     * @name CreatePaymentOrder
     * @summary Создание
     * @request POST:/api/currency-rko/v1/external/payment
     * @secure
     */
    createPaymentOrder: (
      data: PaymentOrderSave,
      query?: { draft?: boolean; ignoreWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError | ValidationResponse>({
        path: `/api/currency-rko/v1/external/payment`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Валютный платеж
     * @name Validate
     * @summary Валидация
     * @request POST:/api/currency-rko/v1/external/payment/validate
     * @secure
     */
    validate: (data: PaymentOrderSave, params: RequestParams = {}) =>
      this.request<ValidationResponse, GenericError>({
        path: `/api/currency-rko/v1/external/payment/validate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ИВО
     * @name CreateCertCurrTransDoc
     * @summary Создание нового ИВО
     * @request POST:/api/currency-rko/v1/external/ivo/create
     * @secure
     */
    createCertCurrTransDoc: (
      data: CertCurrTransDocDetailCreateUpdateRequest,
      query?: { draft?: boolean; ignoreWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, ErrorMessage>({
        path: `/api/currency-rko/v1/external/ivo/create`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Импорт
     * @name ImportMt
     * @summary Импорт документов
     * @request POST:/api/currency-rko/v1/external/import/mt
     * @secure
     */
    importMt: (
      query: { payerName: string; payerAddress: string; draft?: boolean },
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<ImportResult, GenericError>({
        path: `/api/currency-rko/v1/external/import/mt`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Импорт
     * @name ValidateImportMt
     * @summary Валидация документов на импорт
     * @request POST:/api/currency-rko/v1/external/import/mt/validate
     * @secure
     */
    validateImportMt: (
      query: { payerName: string; payerAddress: string },
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<ImportValidateResult, GenericError>({
        path: `/api/currency-rko/v1/external/import/mt/validate`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name Download
     * @summary Получение файла
     * @request GET:/api/currency-rko/v1/external/files
     * @secure
     */
    download: (query: { id: string }, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/currency-rko/v1/external/files`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name UploadFileAttachment
     * @summary Загрузка файла вложения
     * @request POST:/api/currency-rko/v1/external/files
     * @secure
     */
    uploadFileAttachment: (
      query: { documentType: string; category?: string },
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<Attachment, GenericError>({
        path: `/api/currency-rko/v1/external/files`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с выписками
     * @name GetStatementList
     * @summary Получение списка выписок
     * @request GET:/api/currency-rko/v1/external/statements
     * @secure
     */
    getStatementList: (
      query: {
        position: number;
        size: number;
        swiftMessageType?: string;
        accountNumber?: string;
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PageWrappedStatementResponse, GenericError>({
        path: `/api/currency-rko/v1/external/statements`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с выписками
     * @name GetStatementMessage
     * @summary Получить swift сообщение
     * @request GET:/api/currency-rko/v1/external/statements/message
     * @secure
     */
    getStatementMessage: (
      query: { uuid: string },
      params: RequestParams = {}
    ) =>
      this.request<File, GenericError>({
        path: `/api/currency-rko/v1/external/statements/message`,
        method: "GET",
        query: query,
        secure: true,
        format: "formData",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки
     * @name GetSettings
     * @summary Список настроек
     * @request GET:/api/currency-rko/v1/external/settings
     * @secure
     */
    getSettings: (params: RequestParams = {}) =>
      this.request<SettingsResponse, GenericError>({
        path: `/api/currency-rko/v1/external/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Печать
     * @name Print
     * @summary Печать
     * @request GET:/api/currency-rko/v1/external/print
     * @secure
     */
    print: (query: { uuid: string }, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/currency-rko/v1/external/print`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение разрешений
     * @name GetPermissions
     * @summary Получение разрешений на документ
     * @request GET:/api/currency-rko/v1/external/permissions/{documentType}
     * @secure
     */
    getPermissions: (documentType: string, params: RequestParams = {}) =>
      this.request<PermissionListResponse, GenericError>({
        path: `/api/currency-rko/v1/external/permissions/${documentType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Валютный платеж
     * @name GetSwiftMessage
     * @summary Получить swift сообщение
     * @request GET:/api/currency-rko/v1/external/payment/swift
     * @secure
     */
    getSwiftMessage: (query: { id: string }, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/currency-rko/v1/external/payment/swift`,
        method: "GET",
        query: query,
        secure: true,
        format: "formData",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Валютный платеж
     * @name GetPermittedCurrencies
     * @summary Список разрешенных валют
     * @request GET:/api/currency-rko/v1/external/payment/currencies
     * @secure
     */
    getPermittedCurrencies: (params: RequestParams = {}) =>
      this.request<Currency[], GenericError>({
        path: `/api/currency-rko/v1/external/payment/currencies`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Использовать версию 2
     *
     * @tags ИВО
     * @name GetCertCurrTransDocList
     * @summary Получение списка ИВО для клиента
     * @request GET:/api/currency-rko/v1/external/ivo
     * @deprecated
     * @secure
     */
    getCertCurrTransDocList: (
      query?: {
        position?: number;
        size?: number;
        beginDate?: string;
        endDate?: string;
        stateList?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<CertCurrTransDocList, ErrorMessage>({
        path: `/api/currency-rko/v1/external/ivo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ИВО
     * @name GetCertCurrTransDocListV2
     * @summary Получение списка ИВО для клиента. Версия 2
     * @request GET:/api/currency-rko/v1/external/ivo/v2
     * @secure
     */
    getCertCurrTransDocListV2: (
      query?: {
        position?: number;
        size?: number;
        beginDate?: string;
        endDate?: string;
        stateList?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<CertCurrTransDocListV2, ErrorMessage>({
        path: `/api/currency-rko/v1/external/ivo/v2`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Зачисления
     * @name GetEnrollmentList
     * @summary Получение зачислений
     * @request GET:/api/currency-rko/v1/external/enrollment
     * @secure
     */
    getEnrollmentList: (
      query: {
        position: number;
        size: number;
        sort?: string;
        rubles?: boolean;
        trAcc?: string;
        sum?: number;
        curCode?: string;
        documentDateFrom?: string;
        documentDateTo?: string;
        state?: string;
        searchText?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RowsWrappedNoticeEnrollment, GenericError>({
        path: `/api/currency-rko/v1/external/enrollment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Зачисления
     * @name GetEnrollmentDetail
     * @summary Получение детальной информации о зачислении
     * @request GET:/api/currency-rko/v1/external/enrollment/{id}
     * @secure
     */
    getEnrollmentDetail: (id: string, params: RequestParams = {}) =>
      this.request<NoticeEnrollmentDetail, GenericError>({
        path: `/api/currency-rko/v1/external/enrollment/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Документы
     * @name GetDocumentList
     * @summary Получение списка документов
     * @request GET:/api/currency-rko/v1/external/documents
     * @secure
     */
    getDocumentList: (
      query: {
        page: number;
        size: number;
        linkRefId?: string;
        linkRefType?: string;
        beginDate?: string;
        endDate?: string;
        state?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PageWrappedDocumentCommon, GenericError>({
        path: `/api/currency-rko/v1/external/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetSwiftBanks
     * @summary Получение списка SWIFT банков
     * @request GET:/api/currency-rko/v1/external/dict/swift
     * @secure
     */
    getSwiftBanks: (
      query: { searchText: string },
      params: RequestParams = {}
    ) =>
      this.request<Swift[], GenericError>({
        path: `/api/currency-rko/v1/external/dict/swift`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetRuBanks
     * @summary Получение списка Российских банков
     * @request GET:/api/currency-rko/v1/external/dict/ru-bank
     * @secure
     */
    getRuBanks: (query: { searchText: string }, params: RequestParams = {}) =>
      this.request<RuBank[], GenericError>({
        path: `/api/currency-rko/v1/external/dict/ru-bank`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetCurrencies
     * @summary Получение списка Валют
     * @request GET:/api/currency-rko/v1/external/dict/currencies
     * @secure
     */
    getCurrencies: (params: RequestParams = {}) =>
      this.request<Currency[], GenericError>({
        path: `/api/currency-rko/v1/external/dict/currencies`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetCurOperCodes
     * @summary Получение списка Кодов валютных операций
     * @request GET:/api/currency-rko/v1/external/dict/curOperCodes
     * @secure
     */
    getCurOperCodes: (params: RequestParams = {}) =>
      this.request<CurOperCode[], GenericError>({
        path: `/api/currency-rko/v1/external/dict/curOperCodes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetCountries
     * @summary Получение списка Стран
     * @request GET:/api/currency-rko/v1/external/dict/countries
     * @secure
     */
    getCountries: (params: RequestParams = {}) =>
      this.request<Country[], GenericError>({
        path: `/api/currency-rko/v1/external/dict/countries`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочники
     * @name GetAccounts
     * @summary Получение списка Счетов
     * @request GET:/api/currency-rko/v1/external/dict/accounts
     * @secure
     */
    getAccounts: (
      query?: { isNationalCurrency?: boolean; withClosed?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<Account[], GenericError>({
        path: `/api/currency-rko/v1/external/dict/accounts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Данные подписания
     * @name GetOrderCcb
     * @summary Получение ККБ документа
     * @request GET:/api/currency-rko/v1/external/confirmation/order-ccb
     * @secure
     */
    getOrderCcb: (query: { documentId: string }, params: RequestParams = {}) =>
      this.request<OrderCcbResponse, ErrorMessage>({
        path: `/api/currency-rko/v1/external/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Данные подписания
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/currency-rko/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/currency-rko/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Коды
     * @name GetCodes
     * @summary Получение списка Кодов
     * @request GET:/api/currency-rko/v1/external/code
     * @secure
     */
    getCodes: (query: { kind: string }, params: RequestParams = {}) =>
      this.request<Code[], GenericError>({
        path: `/api/currency-rko/v1/external/code`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Коды
     * @name GetCodesKinds
     * @summary Получение списка типов Кодов
     * @request GET:/api/currency-rko/v1/external/code/kinds
     * @secure
     */
    getCodesKinds: (params: RequestParams = {}) =>
      this.request<string[], GenericError>({
        path: `/api/currency-rko/v1/external/code/kinds`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
